// src/layouts/LayoutWithSidebar.tsx
import React from "react";
import Sidebar from "../../Super Admin/SideBar/Sidebar";
import { Outlet } from "react-router-dom";
import "../../../css/LayoutWithSidebar.css";

const LayoutWithSidebar: React.FC = () => {
  return (
    <div className="layout">
      <Sidebar />
      <div className="main-content">
        <Outlet /> {/* This will render page-specific content */}
      </div>
    </div>
  );
};

export default LayoutWithSidebar;
